/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-menu-exim': {
    width: 22,
    height: 20,
    viewBox: '0 0 22 20',
    data: '<g _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path pid="0" d="M12.849 4.942H7.23V2.43s-.063-1.005-1.036-.471L1.424 6.606s-.91.72-.063 1.63c.848.912 4.583 4.616 4.583 4.616s.659.785 1.224.126v-2.826h7.405" _stroke="#234357"/><path pid="1" d="M9.008 15.39h5.618v2.51s.063 1.006 1.036.472l4.77-4.646s.91-.721.064-1.631c-.848-.911-4.583-4.615-4.583-4.615s-.66-.785-1.224-.126v2.826" _stroke="#008AFF"/></g>'
  }
})
